
export class FilterDetails {
    designation: any[];
    location: any[];
    skill: any[];
    department: any[];
    min_exp: number;
    max_exp: number;
    keywords: string;
    //static variables to store the data which are common for all languages 

    //set default values when object is instatiated
    constructor(obj = {
        location: null,
        designation: null,
        department: null,
        skill: null,
        min_exp: 0,
        max_exp: 10,
        keywords: '',

    }) {

        this.location = obj.location || [];
        this.skill = obj.skill || [];
        this.designation = obj.designation || [];
        this.department = obj.department || [];
        this.min_exp = obj.min_exp || 0;
        this.max_exp = obj.max_exp || 10;
        this.keywords = obj.keywords || '';
    }
    //initilaize language values to the object 
    setData(obj) {
        this.location = obj.location || [];
        this.skill = obj.skill || [];
        this.designation = obj.designation || [];
        this.department = obj.department || [];
        this.min_exp = obj.min_exp || 10;
        this.max_exp = obj.max_exp || 0;
        this.keywords = obj.keywords || '';
    }

    //function  to return values which are required for the form group
    getFormGroupData() {
        return {
            skill: this.skill || [],
            location: this.location || [],
            department: this.department || [],
            designation: this.designation || [],
            min_exp: this.min_exp || 0,
            max_exp: this.max_exp || 10
        }
    }

    //function to set the values entered in the form group  in to the object 
    setFormGroupData(obj) {

        this.skill = obj.skill;
        this.location = obj.location;
        this.department = obj.department;
        this.designation = obj.designation;
        this.min_exp = obj.min_exp;
        this.max_exp = obj.max_exp;
    }


}